import "../../styles/all.css";
import "./track.css";
import photo from "../../img/logo.jpg";
import { useTranslation } from "react-i18next";

function Track() {
  const { t } = useTranslation();

  return (
    <>
      <div className="track" data-aos="flip-right">
        <div className="continer">
          <h3>{t("track_title")}</h3>
          <p>{t("track_description")}</p>
        </div>

        <div className="content">

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_front_end_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_front_end_title")}</h5>
              <p>{t("track_front_end_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_back_end_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_back_end_title")}</h5>
              <p>{t("track_back_end_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_ui_ux_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_ui_ux_title")}</h5>
              <p>{t("track_ui_ux_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_full_stack_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_full_stack_title")}</h5>
              <p>{t("track_full_stack_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_mobile_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_mobile_title")}</h5>
              <p>{t("track_mobile_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_digital_marketing_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_digital_marketing_title")}</h5>
              <p>{t("track_digital_marketing_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_graphic_design_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_graphic_design_title")}</h5>
              <p>{t("track_graphic_design_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_devops_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_devops_title")}</h5>
              <p>{t("track_devops_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_data_analyst_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_data_analyst_title")}</h5>
              <p>{t("track_data_analyst_article")}</p>
            </div>
          </div>

          <div className="tracks">
            <div className="image">
              <img src={photo} alt={t("track_ai_engineer_alt")} />
            </div>
            <div className="text">
              <h5>{t("track_ai_engineer_title")}</h5>
              <p>{t("track_ai_engineer_article")}</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Track;
